import React, { useState, useEffect, useRef } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
export interface IcountDownProps {
  duration?: number;
  onTimerUpdate?: Function;
}
const CountDownTimer = (props: IcountDownProps) => {
  const timerProps = {
    isPlaying: true,
    size: 80,
    strokeWidth: 6,
  };
  return (
    <div className="d-flex align-items-center justify-content-center timerspan mgt-15">
      <CountdownCircleTimer
        {...timerProps}
        isPlaying
        duration={props.duration ? props.duration : 120}
        colors={"#51B255"}
        onComplete={() => console.log("times up")}
        onUpdate={(rem) => {
          props?.onTimerUpdate(rem);
        }}
      >
        {({ remainingTime }: any) =>
          "" + Math.floor(remainingTime / 60) + ":" + (remainingTime % 60) + ""
        }
      </CountdownCircleTimer>
    </div>
  );
};

export default CountDownTimer;
